import { SPACE, SPACE_MEMBER  } from "actions/types";
import { baseStore } from "./common/baseStore"

const spaceReducers = {
  space: baseStore(SPACE),
  spaceMember: baseStore(SPACE_MEMBER),
};
export default spaceReducers;
